<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="310" scrollable>
      <v-card color="gray" max-height="500">
        <v-card-title class="headline" primary-title>
          Velg symbol
        </v-card-title>

        <v-card-text v-if="dialog">
          <v-container grid-list-md>
            <v-item-group v-model="selectedIndex">
              <v-layout
                row
                wrap
                align-center
                justify-center
                justify-space-around
              >
                <v-item v-for="(item, i) in symbols" :key="i">
                  <v-card
                    flat
                    class="pa-3"
                    slot-scope="{ active, toggle }"
                    @click.stop="
                      toggle;
                      selectSymbol(i);
                    "
                  >
                    <div style="display:table;">
                      <div
                        style="display:table-cell;vertical-align:middle;"
                        v-html="item"
                      ></div>
                    </div>
                  </v-card>
                </v-item>
              </v-layout>
            </v-item-group>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeDialog">
            Lukk
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      selectedIndex: 0,
      theSvg: null
    };
  },
  name: "MapDrawingSymbolSelectionDialog",
  props: {
    active: Boolean,
    symbols: Array,
    index: Number,
    tool: String,
    selectedSymbol: String
  },
  watch: {
    active(val) {
      this.dialog = val;
    }
  },
  methods: {
    selectSymbol: function(index) {
      this.$emit("symbol-selected", this.tool, index);
    },
    closeDialog: function() {
      this.$emit("close-dialog");
    }
  },
  mounted() {
    this.selectedIndex = this.index;
  }
};
</script>
<style scoped></style>
